import config from "../../config";
import axios from "axios";
import {getCookie} from "../common/utils";
import appErrorLogger from "../common/DataDogErrorLog";

const setAxiosInstance = () => {
    const auth_token = getCookie('auth_token');
    return axios.create({
        baseURL: `${config.host_rebag_api}/v6/self-check-in`,
        timeout: 15000,
        headers: {'Authorization': auth_token}
    });
};

const getPaymentMethods = (callback) => {
    setAxiosInstance().get("/payments/profiles/")
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => appErrorLogger('Get Payment Methods', error));
}

const postShippingMethods = (callback, data) => {
    return (dispatch, _) => {
        setAxiosInstance().post("/shipping/", data)
            .then((response) => {
                if(callback){
                    callback(response.data.shipping);
                } else {
                    dispatch({
                        type: 'SET_SHIPPING_METHODS',
                        shipping_methods: response.data.shipping
                    })
                }

            })
            .catch((error) => appErrorLogger('Post Shipping Methods', error));
    }
}

const createACHProfile = (data, callback) => {
    setAxiosInstance().post("/payments/create_profile/ach/", data)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            appErrorLogger('Create ACH Profile', error)
            if(error.response){
                const server_error = error.response.data;
                if(server_error.detail){
                    callback(error.response.data);
                }
            } else {
                callback("Server was busy, please come back later!");
            }
        })
}

const addAddress = (data, callback) => {
    setAxiosInstance().post("/address/", data)
        .then((response) => {
            callback(response);
        })
        .catch((error) => {
            appErrorLogger('Add Address', error)
            const server_error = error.response.data;
            if(server_error.detail){
                callback(error.response.data);
            }
        })
}

const getAddresses = (callback) => {
    setAxiosInstance().get("/address/")
        .then((response) => {
            callback(response.data.addresses);
        })
        .catch((error) => appErrorLogger('Get Addresses', error));
};

const getPickupScheduleDays = (callback) => {
    setAxiosInstance().get("/shipping/pickup/schedule-days/")
        .then((response) => {
            callback(response.data.schedule);
        })
        .catch((error) => appErrorLogger('Get Pickup Scheduled Days', error));
};

const sendDeclinedProvideInfo = (evaluation_id, zendesk_ticket, nextNMIEvaluation, history, reason) => {
    return (dispatch, _) => {
        let payload = {
            "accepted": [],
            "declined": [Number(evaluation_id)],
            "declined_from_nmi": true
        }

        if (reason) {
            payload = {refused: {[Number(evaluation_id)]: reason}}
        }

        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().put(`/finalize-quote/${zendesk_ticket}/`, payload)
            .then((response) => {
                if (nextNMIEvaluation) {
                    history.push(`/submissions/provide-information/${zendesk_ticket}/${nextNMIEvaluation.id}`);
                } else {
                    history.push("/submissions/");
                }
            })
            .catch((error) => {
                appErrorLogger('Decline NMI evaluation', error);
            })
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            });
    }
}

export {
    getPaymentMethods,
    createACHProfile,
    getAddresses,
    addAddress,
    getPickupScheduleDays,
    sendDeclinedProvideInfo,
    postShippingMethods,
}